export default __webpack_public_path__ + "309feac.png";